import { sendEvent } from '../../../../../core/services/tracking';

function useContactModal(posData) {
  function onClickPhone() {
    sendEvent({
      event_type: 'click',
      object_detail: 'comunication',
      point_of_sale: 'cars-subscription-bundle',
      funnel_id: posData.funnelId,
      data: {
        type: 'phone',
      },
    });
    window.open('tel:08000229800');
  }

  function onClickSupport() {
    sendEvent({
      event_type: 'click',
      object_detail: 'comunication',
      point_of_sale: 'cars-subscription-bundle',
      funnel_id: posData.funnelId,
      data: {
        type: 'lead-collector',
      },
    });
    window.open('http://marketing.olx.com.br/Sales/POS/lead_collector_standalone_carros.html');
  }

  function onClickWhatsApp() {
    sendEvent({
      event_type: 'click',
      object_detail: 'comunication',
      point_of_sale: 'cars-subscription-bundle',
      funnel_id: posData.funnelId,
      data: {
        type: 'whatsapp',
      },
    });
    window.open('https://api.whatsapp.com/send?phone=5511953106412&text=Ol%C3%A1%2C%20tenho%20interesse%20nas%20ofertas%20especiais%20dos%20novos%20Planos%20Profissionais%20para%20Carros%20da%20OLX.%20%20');
  }

  return {
    onClickPhone,
    onClickSupport,
    onClickWhatsApp,
  };
}

export default useContactModal;
